/** @format */
import React, { useEffect } from "react";

import {
  CardStatistik,
  CardStatistikDetail,
  CardStatistikProgress,
} from "./Component/CardStatistik";
import { countPersentase } from "utils/helper";
import { CardTable } from "./Component/CardTable";
import { shallowEqual, useSelector } from "react-redux";
import { useDashboardIndikatif } from "hooks/HookBos/useDashboardIndikatif";

// import ModalValidasiDanaBos from "../../components/Modal/ModalValidasiDanaBos";

const DashboardIndikatif = () => {
  const { auth } = useSelector(
    (state: any) => ({
      auth: state.auth?.data || null,
    }),
    shallowEqual,
  );

  const { indikatifHeader1, indikatifHeader2, fetchData, loading } =
    useDashboardIndikatif(auth);

  useEffect(() => {
    if (!auth?.isTahun) return;

    fetchData(true, null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.isTahun]);

  return (
    <div className="p-5">
      <div className="flex flex-col md:flex-row gap-4 mb-4">
        <div className="flex-1 flex flex-col md:flex-row  gap-4">
          <CardStatistik
            title="Saldo Rencana"
            valuePrimary={indikatifHeader1?.saldoRencana || 0}
            prefix="Rp"
            loading={loading}
          />
          <CardStatistikProgress
            title="Rencana Indikatif"
            valuePrimary={indikatifHeader1?.rencanaPendapatan || 0}
            valueSecondary={indikatifHeader1?.rencanaBelanja || 0}
            persent={countPersentase(
              indikatifHeader1?.rencanaBelanja || 0,
              indikatifHeader1?.rencanaPendapatan || 0,
            )}
            prefix="Rp"
            loading={loading}
          />
        </div>
        <div className="flex-1">
          <CardStatistikDetail
            title="Rencana"
            valuePrimary={indikatifHeader1?.rencanaSelesai || 0}
            valueSecondary={indikatifHeader1?.rencanaBelumSelesai || 0}
            prefix="Rp"
            loading={loading}
            type="indikatif"
          />
        </div>
      </div>
      <CardTable
        title=""
        data={indikatifHeader2}
        type="detailLokasiIndikatif"
        loading={loading}
      />
    </div>
  );
};

export default DashboardIndikatif;
